import { ActivityLogTypeEnum } from '@/@data'
import { LiftActivityLog } from '@/components/log/LiftActivityLog'
import Link from '@/components/Link'

export const LiftUserActivityLog = () => {
  const { __ } = useTranslator();

  return (
    <LiftActivityLog
      object_type={ActivityLogTypeEnum.User}
      breadcrumb={
        <Link color='inherit' href='/cms/users/lift-user'>
          {__('Lift Management')}
        </Link>
      }
    />
  )
}
